import {Box, BoxProps} from "@mui/material";
import {PropsWithChildren} from "react";

const MultilineTextClamp = ({line, sx={}, ...props}:{
    line?: number,
    sx?: BoxProps['sx'],
} & PropsWithChildren) => {
    return <Box sx={!!line ? {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: line,
        WebkitBoxOrient: "vertical",
        ...sx,
    } : sx}>{props?.children}</Box>
}

export default MultilineTextClamp;